module.exports = __webpack_public_path__ + "static/img/academic1.2de6fdbe.png";